const qualCode: any = {
  "degree-courses": "M",
  "hnd-hnc-courses": "N",
  "foundation-degree-courses": "A",
  "access-foundation-courses": "T",
  "postgraduate-courses": "L",
};
const KeyNames = () => {
  const sameNameObject = {
    month: "month",
    year: "year",
    location: "location",
    sort: "sort",
    university: "university",
    postcode: "postcode",
    distance: "distance",
    score: "score",
  };
  if (process.env.PROJECT === "Whatuni") {
    return {
      ...sameNameObject,
      subject: "subject",
      keyword: "q",
      studyMethod: "study-method",
      studyMode: "study-mode",
      // universityGroup: "university-group",
      locationType: "location-type",
      pageNumber: "pageno",
      russellGroup: "russell-group",
      studyLevel: "study-level",
      award_type: "award-type",
      award_coverage: "award-coverage",
      nationality: "nationality",
    };
  } else {
    return {
      ...sameNameObject,
      subject: "course",
      keyword: "keyword",
      studyMethod: "study_method",
      studyMode: "study_mode",
      // universityGroup: "university_group",
      locationType: "location_type",
      pageNumber: "page_no",
      russellGroup: "russell_group",
      studyLevel: "qualification",
      award_type: "award-type",
      award_coverage: "award-coverage",
      nationality: "nationality",
    };
  }
};
const keyName = KeyNames();
const splitValue = (value: string | undefined, delimiter: string = " ") => {
  if (!value) return [];
  return value.includes("+") ? value.split("+") : value.split(delimiter);
};

const toUpperArray = (value: string | undefined) => {
  if (!value) return [];
  return value.toUpperCase().split(" ");
};

const filterbodyJson = (inputObject: any, parentQual: string) => {
  const get = (key: string | undefined) =>
    key ? inputObject?.[key] || "" : "";
  const getSplit = (key: string | undefined) => splitValue(get(key));
  const getUpperArray = (key: string | undefined) => toUpperArray(get(key));
  return {
    parentQualification: qualCode?.[parentQual] || "",
    childQualification: get(keyName?.studyLevel),
    searchCategoryCode: "",
    searchSubject: getSplit(keyName?.subject),
    searchKeyword: getSplit(keyName?.subject)?.length===0 ? get(keyName?.keyword) : "",
    jacsCode: inputObject?.jacs || "",
    location: getSplit(keyName?.location),
    studyMode: get(keyName?.studyMode),
    studyMethod: get(keyName?.studyMethod),
    collegeName: get(keyName?.university),
    pageNo: get(keyName?.pageNumber),
    locationType: getSplit(keyName?.locationType),
    intakeYear: null,
    intakeMonth: inputObject?.month?.toUpperCase() || "",
    sortBy: get(keyName?.sort),
    userCoordinates: "",
    distance: get(keyName?.distance) === "any" ? "" : get(keyName?.distance),
    ucasTariffRange: get(keyName?.score),
    userRegionArray: "",
    dynamicRandomNumber: "",
    universityGroup: getUpperArray(keyName?.russellGroup),
    postCode: get(keyName?.postcode)?.toUpperCase().replaceAll("+", " ") || "",
    pageName: get(keyName?.university) ? "provider-results" : "search-results",
  };
};

export { filterbodyJson, qualCode, KeyNames };
